<template>
  <div class="experience-path-report">
    <div class="content"></div>
  </div>
</template>
<script>
export default {
  name: "ExperiencePathReport",

  mounted() {
    let highlighted = document.querySelector(".region-highlighted");
    let content = document.querySelector(".region-content");
    if (highlighted && highlighted != null) {
      this.$el.querySelector(".content").append(highlighted);
    }
    this.$el.querySelector(".content").append(content);
  },

  data() {
    return {
      websiteTitle: window.drupalSettings.website.title,
      websiteLogo: window.drupalSettings.website.logo,
      logoAlt: window.drupalSettings.website.logo + " logo",
    };
  },

  methods: {},
};
</script>
<style lang="scss">
  .experience-path-report {
    th a {
      color: $white !important;
    }
  }
</style>
